'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Divider = require('../Dividers/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFieldDivider = function (_PureComponent) {
  _inherits(TextFieldDivider, _PureComponent);

  function TextFieldDivider() {
    _classCallCheck(this, TextFieldDivider);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  TextFieldDivider.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        error = _props.error,
        lineDirection = _props.lineDirection,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);

    return _react2.default.createElement(_Divider2.default, _extends({}, props, {
      className: (0, _classnames2.default)('md-divider--text-field md-divider--expand-from-' + lineDirection, {
        'md-divider--text-field-expanded': active,
        'md-divider--text-field-active': !error && active,
        'md-divider--text-field-error': error
      }, className)
    }));
  };

  return TextFieldDivider;
}(_react.PureComponent);

TextFieldDivider.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  error: _propTypes2.default.bool,
  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right'])
};
exports.default = TextFieldDivider;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/TextFields/TextFieldDivider.js
// module id = 343
// module chunks = 213534597649335